import { Checkbox, Divider, FormControlLabel, Grid, Typography } from "@mui/material";
import { ActivityFormConfig } from "../utils/activityFormConfig";

type ActivityScreeningActivationFieldsProps = {
  config: ActivityFormConfig;
  translate: (key: string) => string;
  withLogging: boolean;
  fullBiomassScreeningEnabled: boolean;
  fullBiomassScreeningUnavailable: boolean;
  disabled: boolean;
  onFullBiomassScreeningEnabledChange: (enabled: boolean) => void;
};

const ActivityScreeningActivationFields = ({
  config,
  translate,
  withLogging,
  fullBiomassScreeningEnabled,
  fullBiomassScreeningUnavailable,
  disabled,
  onFullBiomassScreeningEnabledChange,
}: ActivityScreeningActivationFieldsProps) => {
  const showFullScreeningToggle =
    withLogging && config.isVisible("infoBiomassScreeningEnableScreening");

  if (!showFullScreeningToggle) return null;

  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: -2 }}>
          {translate("activity-screening")}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={fullBiomassScreeningEnabled && !fullBiomassScreeningUnavailable}
              onChange={(event) => onFullBiomassScreeningEnabledChange(event.target.checked)}
            />
          }
          label={translate("activity-full-biomass-screening-enabled")}
          disabled={
            disabled ||
            fullBiomassScreeningUnavailable ||
            config.isDisabled("infoBiomassScreeningEnableScreening")
          }
          sx={{ ml: 0 }}
        />
      </Grid>
    </>
  );
};

export default ActivityScreeningActivationFields;
